
<div class="ranking">
	<app-big-loader
		*ngIf="loading"
	/>
	<app-ranking-row
		*ngFor="let item of ranking"
		[row]="item"
	/>
</div>

